import { AppRegistry } from 'react-native';
import App from './App';

AppRegistry.registerComponent('CestouGestao', () => App);

if (window.document) {
    AppRegistry.runApplication('CestouGestao', {
        rootTag: document.getElementById('root')
    });
}
